exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".EulaPrompt-document {\n  max-height: 280px;\n  overflow-y: auto;\n  margin-top: 32px;\n  padding: 16px;\n  background: #f7f9fb;\n  border: 1px solid #e2e4e6;\n  border-radius: 2pxl; }\n", ""]);

// exports
